/**
 * Organisation Types Collection.
 *
 * Contains static list of available ticket's message types, which can be used for different
 * purposes, like filling lists, allowing options selection, etc.
 */
export default [
  {
    key: 'customer',
    value: 'Customer',
    icon: 'building-05',
  },
  {
    key: 'independent_contractor',
    value: 'Independent contractor',
    icon: 'building-05',
  },
  {
    key: 'internal',
    value: 'Internal',
    icon: 'building-05',
  },
  {
    key: 'partner',
    value: 'Service partner',
    icon: 'building-05',
  },
  {
    key: 'third_party',
    value: 'Third party',
    icon: 'building-05',
  },
]
